// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"c46d5cf6","562":"b140fda7","877":"c46d5cf6","972":"c46d5cf6"}[chunkId] + ".chunk.css";
};